<template>
  <LayoutPicker id="app">
    <router-view
      :key="`${$route.path}-${$route.params.id || null}`"
    ></router-view>
  </LayoutPicker>
</template>

<script>
import { useTitle } from '@vueuse/core'
import { computed, provide } from 'vue'

import { brandShort } from '@/../app.config'
import { useStore } from '@/store'

import LayoutPicker from '@/layouts/LayoutPicker.vue'

export default {
  name: 'App',
  components: {
    LayoutPicker,
  },
  setup() {
    useTitle(`${brandShort}: Your one stop shop for lab management.`)

    const store = useStore()
    provide(
      'isSuperUser',
      computed(() => store.getters['auth/isAdminUser']),
    )
  },
}
</script>

<style lang="css">
@import '@fortawesome/fontawesome-free/css/all.css';
@import '@/assets/styles/tokens/theme.css';
@import '@/assets/styles/fonts.css';
@import '@/assets/styles/components/data-loader-tables.css';
</style>

<style lang="scss">
@use '@/assets/styles/tokens/compat';
@use 'bulma';
@use '@/assets/styles/vendor/bulma-adapter.scss' as bulma-adapter;
@use '@/assets/styles/vendor/bulma.scss' as bulma-ext;
@use '@/assets/styles/global.scss';
@use '@/assets/styles/components/data-loader.scss';
@use '@/assets/styles/components/detail-field-grid.scss';
@use '@/assets/styles/tokens/z-index';
@use '@/assets/styles/components/ui-elements.scss';
</style>

<style lang="css">
#app {
  font-family: var(--font-body);
  height: 100vh;
  width: 100vw;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}

.server-down.notification {
  display: flex;
  justify-content: center;
  max-width: unset;
  padding: 1rem;
  border-radius: 0;
  margin: 0;
  z-index: var(--z-notification);
}

.modal {
  z-index: var(--z-modal);
}
</style>
